const getAccessToken = state => state.accessToken
const getExpiresIn = state => state.expiresIn
const getTokenType = state => state.tokenType
const getIsAuthorized = state => null != state.accessToken
const getActiveOrganization = state => state.activeOrganization
const getDefaultOrganization = state => state.defaultOrganization
const getSpeedUnit = state => state.speedUnit
const getGivenName = state => state.givenName
const getFamilyName = state => state.familyName
const getPermissions = state => state.permissions
const getUserId = state => state.user_id
const getUserSession = state => state.userSession
const getIsImpersonateActive = state => state.activeOrganization !== state.defaultOrganization

export default {
    getAccessToken,
    getExpiresIn,
    getTokenType,
    getIsAuthorized,
    getActiveOrganization,
    getDefaultOrganization,
    getSpeedUnit,
    getGivenName,
    getFamilyName,
    getPermissions,
    getUserId,
    getUserSession,
    getIsImpersonateActive
}
